import axios from 'axios';

// Use empty string for production (same-origin), localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL !== undefined
  ? process.env.REACT_APP_API_URL
  : 'http://localhost:8100';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface MitarbeiterProfile {
  id: number;
  vorname: string;
  nachname: string;
  rolle: string;
  ist_aktiv: boolean;
  email: string;
  telefon: string;
  winchim_mitarbeiter_id: string | null;
}

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  mitarbeiter: MitarbeiterProfile | null;
}

export interface LoginResponse {
  access: string;
  refresh: string;
  user: User;
}

export interface ApiError {
  error: string;
}

class AuthAPI {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    const response = await axios.post<LoginResponse>(
      `${API_BASE_URL}/api/v1/auth/login/`,
      credentials
    );
    return response.data;
  }

  async getCurrentUser(token: string): Promise<User> {
    const response = await axios.get<User>(
      `${API_BASE_URL}/api/v1/auth/me/`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  }

  async refreshToken(refreshToken: string): Promise<{ access: string }> {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/auth/refresh/`,
      { refresh: refreshToken }
    );
    return response.data;
  }

  async logout(refreshToken: string, accessToken: string): Promise<void> {
    await axios.post(
      `${API_BASE_URL}/api/v1/auth/logout/`,
      { refresh: refreshToken },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    );
  }
}

export const authAPI = new AuthAPI();
